import { createFontSizeCSS } from '@hellodarwin/core/lib/theme/global-style';
import styled, { css } from 'styled-components';
export const ShowcaseFeatureList = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}px;
  width: 100%;
  margin-block-end: ${({ theme }) => theme.spacing.md}px;
`;
export const ShowcaseTileSummary = styled.div `
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.md}px;
  width: 100%;
`;
export const ShowcaseTilePlan = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}px;
  width: 100%;
`;
export const ShowcaseTileType = styled.div `
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.sm}px;
  width: 100%;
`;
export const ShowcaseTileHeader = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-block: 20px;
  padding-inline: 32px;
  gap: 12px;
  height: 246px !important;
  justify-content: space-between;
`;
export const ShowcaseTileBody = styled.div `
  width: 100%;
  padding-block: 20px;
  padding-inline: 32px;
  ${createFontSizeCSS('body1')}
  border-top: 1px solid ${({ theme }) => theme.colors.grey_1};
`;
export const getPlanTheme = (planType, theme) => {
    switch (planType) {
        case 'premium':
            return {
                background: theme.colors.yellow_4,
                ctaColor: 'yellow_1',
                tagColor: theme.colors.yellow_1,
                toggleColor: theme.colors.yellow_2,
                toggleBorderColor: theme.colors.yellow_1,
            };
        case 'free':
            return {
                background: theme.colors.green_4,
                ctaColor: 'green_1',
                tagColor: theme.colors.green_1,
                toggleColor: theme.colors.green_3,
                toggleBorderColor: theme.colors.green_1,
            };
        case 'custom':
            return {
                background: theme.colors.purple_5,
                ctaColor: 'purple_1',
                tagColor: theme.colors.purple_3,
                toggleColor: theme.colors.purple_3,
                toggleBorderColor: theme.colors.purple_1,
            };
    }
};
const StyledPlanTile = (planType, theme) => {
    const planTheme = getPlanTheme(planType !== null && planType !== void 0 ? planType : 'free', theme);
    return css `
    ${ShowcaseTileHeader} {
      background-color: ${planTheme.background};
    }
    --toggle-color: ${planTheme.toggleColor};
    --toggle-border-color: ${planTheme.toggleBorderColor};
  `;
};
export const ShowcaseTileCard = styled.div `
  background-color: ${({ theme }) => theme.colors.white_1};
  border-radius: ${({ theme }) => theme.border_radius.sm};
  display: flex;
  flex-direction: column;
  width: 100%;
  align-self: stretch;
  overflow: hidden;
  ${({ $planType, theme }) => StyledPlanTile($planType, theme)};

  ${({ $highlighted, theme }) => $highlighted
    ? css `
          box-shadow: 0px 0px 6px 2px ${theme.colors.purple_4}AA;
          border: 3px solid ${theme.colors.purple_1};
        `
    : css `
          border: 1px solid ${theme.colors.grey_3};
        `};
`;
export const ShowcaseTileToggleWrapper = styled.div `
  border: 1px solid ${({ theme }) => theme.colors.grey_4};
  box-shadow: ${({ theme }) => theme.appearance.box_shadow};
  border-radius: ${({ theme }) => theme.border_radius.sm};
  width: fit-content;
`;
export const ShowcaseTileToggleContainer = styled.div `
  --toggle-border-radius: ${({ theme }) => theme.border_radius.xs};
  display: flex;
  flex-direction: row;
  gap: 0;
  align-items: stretch;
  border: 2px solid var(--toggle-color);
  border-radius: var(--toggle-border-radius);
  width: max-content;
  background: var(--toggle-color);
`;
export const ShowcaseTileToggleItem = styled.div `
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-inline: ${({ theme }) => theme.appearance.spacing * 1.5}px;
  padding-block: ${({ theme }) => theme.appearance.spacing * 1}px;
  cursor: pointer;
  border-radius: var(--toggle-border-radius);
  ${({ $active, theme }) => $active
    ? css `
          background-color: ${theme.colors.white_1};
          border: 1px solid var(--toggle-border-color);
        `
    : css `
          border: 1px solid ${({ theme }) => theme.colors.transparent};
        `};
`;
export const LineItemContainer = styled.div `
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.appearance.spacing * 1.5}px;
  p {
    margin-block: 0;
  }
`;
